import { Heading, HeadingProps } from '@chakra-ui/react';
import { memo } from 'react';

export default memo(function SectionSubHeading(props: HeadingProps) {
  return <Heading as={'h3'} size={'md'} mt={6} mb={4} {...props} />;
});
